import ApplicationController from 'javascript/controllers/application_controller';

const DEFAULT_TRACK_URL = '/app_download_clicks';
const DEFAULT_SOURCE = 'ticket_wallet';

const safeString = (value, fallback) => {
  if (value === undefined || value === null) return fallback;
  const str = String(value);
  if (str === '' || str === 'undefined' || str === 'null') return fallback;
  return str;
};

export default class extends ApplicationController {
  trackAppStore() {
    this.#track('app_store');
  }

  trackGooglePlay() {
    this.#track('google_play');
  }

  #track(store) {
    const csrfToken = document.querySelector(
      'meta[name="csrf-token"]',
    )?.content;

    const source = safeString(
      this.element.dataset.appDownloadCtaSourceValue,
      DEFAULT_SOURCE,
    );
    const eventSlug = safeString(
      this.element.dataset.appDownloadCtaEventSlugValue,
      '',
    );
    const url = safeString(
      this.element.dataset.appDownloadCtaTrackUrlValue,
      DEFAULT_TRACK_URL,
    );

    const body = new FormData();
    body.append('store', store);
    body.append('source', source);
    if (eventSlug) body.append('event_slug', eventSlug);

    try {
      fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': csrfToken || '',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body,
        credentials: 'same-origin',
        keepalive: true,
      });
    } catch (_e) {
      // Tracking failures must never block navigation to the store.
    }
  }
}
